import { Button, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { apiCall } from "../../../utils/helpers";

export default function HealthQuestions({
  healthQuestions = [],
  setHealthQuestions = () => {},
  step = 0,
  setStep = () => {},
  verifying = false,
  setVerifying = () => {},
  onBoardingUser = {},
}) {
  const getQuestionsList = () => {
    setVerifying(true);
    apiCall
      .post("v1/dopamine/getHealthscoreQuestions", {
        api_name: "getHealthscoreQuestions",
        // key: "JWT",
        // secret: "DOPAMINE"
        auth: onBoardingUser?.token,
      })
      .then((res) => {
        setVerifying(false);
        if (res.status === 200 && res.data.success)
          setHealthQuestions(res.data.data);
        else console.log(res.data.msg);
      })
      .catch((err) => {
        console.log(err);
        setVerifying(false);
      });
  };

  const questionsLeft = healthQuestions.filter((b) => b?.answer === 0);

  useEffect(() => {
    getQuestionsList();
  }, []);

  return (
    <>
      <div
        className="onboarding-step onboarding-step-6"
        style={{ padding: "1rem" }}
      >
        <p
          style={{
            margin: "20px 0 20px 0",
            fontSize: "26px",
            fontWeight: 700,
            textAlign: "center",
            color: "#CFCFCF",
          }}
        >
          Get health score
        </p>
        <div style={{ padding: "6%" }}>
          {healthQuestions?.map((question, i) => (
            <div
              key={i}
              style={{
                padding: 1,
                marginBottom: "16px",
                borderRadius: "12.9612px",

                background:
                  "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
              }}
            >
              <div className="question-card">
                <div className="question-div">
                  {/* <div className="question-number">{question?.question_id}</div> */}
                  <p className="question">
                    {question?.question_id}. {question?.question}
                  </p>
                </div>
                <div className="buttons-div">
                  <div
                    style={{
                      padding: 1,
                      borderRadius: "11.6279px",

                      background:
                        "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        boxShadow: "none",
                        borderRadius: "11.6279px",
                        width: 78,
                        fontSize: 16,
                        fontWeight: 500,
                        color:
                          question?.answer !== -50 ? " #CFCFCF " : "#272727",
                        background:
                          question?.answer !== -50
                            ? "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)"
                            : "radial-gradient(99.17% 99.17% at 50% 50%, #DADADA 0%, #121212 100%)",
                      }}
                      onClick={() => {
                        const newState = healthQuestions.map((obj, objId) => {
                          if (objId === i) {
                            return { ...obj, answer: -50 };
                          }
                          return obj;
                        });
                        setHealthQuestions(newState);
                      }}
                    >
                      Yes
                    </Button>
                  </div>
                  <div
                    style={{
                      padding: 1,
                      borderRadius: "11.6279px",

                      background:
                        "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        width: 78,

                        boxShadow: "none",
                        borderRadius: "11.6279px",
                        fontSize: 16,
                        fontWeight: 500,
                        color:
                          question?.answer !== 50 ? " #CFCFCF " : "#272727",
                        background:
                          question?.answer !== 50
                            ? "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)"
                            : "radial-gradient(99.17% 99.17% at 50% 50%, #DADADA 0%, #121212 100%)",
                      }}
                      onClick={() => {
                        const newState = healthQuestions.map((obj, objId) => {
                          if (objId === i) {
                            return { ...obj, answer: 50 };
                          }
                          return obj;
                        });
                        setHealthQuestions(newState);
                      }}
                    >
                      No
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {!healthQuestions.length && (
          <div
            style={{
              margin: "2rem auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
      </div>
      <div className="request-footer-btn">
        <Button
          onClick={() => setStep(step + 1)}
          disabled={verifying || questionsLeft?.length}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",
            background:
              verifying || questionsLeft?.length
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color: verifying || questionsLeft?.length ? "#232323" : "#FF4A01",
          }}
        >
          {verifying ? "Calculating..." : "Get score"}
        </Button>
      </div>
    </>
  );
}
